// Per-frame riding, scooter placement and the chase camera.
import { cam } from '../core/scene.js';
import { colliders } from '../world/eixample.js';
import { V } from '../world/sagrada.js';
import { lean, moto, wheels } from '../vehicles/scooter.js';
import { S, keys, lookAt, wrapAngle } from './ride.js';
import { touch } from './input.js';
import { collide, groundHeight } from './physics.js';
import { state } from '../core/state.js';
import { speed } from '../dom.js';

export let ride, placeMoto, chaseCam;

export function buildRiding() {
  ride = function ride(dt) {
    const clamp1 = (v) => Math.max(-1, Math.min(1, v));
    const thr = clamp1(
      (keys.KeyW || keys.ArrowUp ? 1 : 0) - (keys.KeyS || keys.ArrowDown ? 1 : 0) + touch.thr,
    );
    const st = clamp1(
      (keys.KeyA || keys.ArrowLeft ? 1 : 0) - (keys.KeyD || keys.ArrowRight ? 1 : 0) + touch.st,
    );
    // off the road the bike crawls: about half speed on sidewalks and the promenade, a third on the sand (no boost on either)
    const surface = S.z > 51.5 ? 'sand' : groundHeight(S.x, S.z) > 0.2 ? 'walk' : 'road';
    const vmax =
      surface === 'sand'
        ? 3.6
        : surface === 'walk'
          ? 5.2
          : keys.ShiftLeft || keys.ShiftRight || touch.boost
            ? 17
            : 11;
    if (thr > 0) S.v += (S.v < 0 ? 22 : 9) * thr * dt;
    else if (thr < 0) S.v -= (S.v > 0 ? 22 : 6) * -thr * dt;
    else S.v *= Math.exp(-1.2 * dt);
    if (keys.Space || touch.brake) S.v *= Math.exp(-5 * dt);
    if (S.v > vmax) S.v = Math.max(vmax, S.v - (surface === 'road' ? 15 : 22) * dt);
    if (S.v < -vmax) S.v = Math.min(-vmax, S.v + 22 * dt);
    S.v = Math.max(S.v, -4);
    S.steer += (st - S.steer) * Math.min(1, 8 * dt);
    S.th +=
      S.steer *
      2.1 *
      Math.min(1, Math.abs(S.v) / 3) *
      Math.sign(S.v) *
      (1 - Math.min(0.45, Math.abs(S.v) / 40)) *
      dt;
    S.x += Math.sin(S.th) * S.v * dt;
    S.z += Math.cos(S.th) * S.v * dt;
    collide();
    S.y += (groundHeight(S.x, S.z) - S.y) * Math.min(1, 20 * dt);
    speed.firstChild.nodeValue = Math.round(Math.abs(S.v) * 5);
  };
  placeMoto = function placeMoto(dt) {
    moto.position.set(S.x, S.y, S.z);
    moto.rotation.y = S.th;
    lean.rotation.z +=
      (-S.steer * Math.min(1, Math.abs(S.v) / 8) * 0.42 * Math.sign(S.v) - lean.rotation.z) *
      Math.min(1, 10 * dt);
    for (const w of wheels) w.rotation.x += (S.v * dt) / (0.39 * 0.8);
  };
  chaseCam = function chaseCam(dt) {
    state.camHead += wrapAngle(S.th - state.camHead) * Math.min(1, 2.5 * dt);
    const want = V(
      S.x - Math.sin(state.camHead) * state.camDist,
      S.y + state.camDist * 0.8 + 2,
      S.z - Math.cos(state.camHead) * state.camDist,
    );
    for (const c of colliders) {
      if (!c.top) continue;
      const inside =
        c.type === 'oct'
          ? Math.abs(want.x - c.cx) < c.h + 1 &&
            Math.abs(want.z - c.cz) < c.h + 1 &&
            Math.abs(want.x - c.cx) + Math.abs(want.z - c.cz) < 2 * c.h - c.ch + 2
          : want.x > c.x0 - 1 && want.x < c.x1 + 1 && want.z > c.z0 - 1 && want.z < c.z1 + 1;
      if (inside) want.y = Math.max(want.y, c.top);
    }
    cam.position.lerp(want, 1 - Math.exp(-4 * dt));
    lookAt.lerp(
      V(S.x + Math.sin(S.th) * 3, S.y + 1.4, S.z + Math.cos(S.th) * 3),
      1 - Math.exp(-8 * dt),
    );
    cam.lookAt(lookAt);
  };
}
